import React from 'react';
import {getName} from "../../common/functions/common";

const initialState = {
    socketId: '',
    currentUser: ''
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'GET_CURRENT_USER': {
            if (action?.payload && !action?.payload?.label) action.payload.label = getName(action?.payload)
            if (action?.payload && !action?.payload?.value) action.payload.value = action?.payload?._id
            return {...state, currentUser: {...action.payload}}
        }


        default: {
            return state;
        }
    }
}
